import clsx from 'clsx';

import styles from './style.module.scss';

export const BaseLayout = ({ children, className }) => (
  <div className={clsx(styles.container, {
    [className]: className
  })}>{children}</div>
);
